(function () {
  /**
   * Checks for mobile buttons.
   * This originally came from Drupal.olivero so we needed to improvise for the
   * current installation.
   */
  function isDesktopNav() {
    let navButtons = document.querySelector('.mobile-buttons');
    return getComputedStyle(navButtons).getPropertyValue('display') === 'none';
  }

  /**
   * Checks if navWrapper contains "is-active" class.
   * @param {object} navWrapper
   *   Header navigation.
   * @return {boolean}
   *   True if navWrapper contains "is-active" class, false if not.
   */
  function isNavOpen(navWrapper) {
    return navWrapper.classList.contains('is-active');
  }

  /**
   * Reset submenu open state when the main mobile nav closes.
   */
  function resetSubNavState() {
    document.querySelectorAll('.primary-nav__menu-item--has-children')
      .forEach((menuItem) => {
        const button = menuItem.querySelector('.primary-nav__button-toggle');
        const subMenu = menuItem.querySelector('.primary-nav__menu');

        if (button) {
          button.setAttribute('aria-expanded', 'false');
        }

        if (subMenu) {
          subMenu.classList.remove('is-active');
        }
      });
  }

  /**
   * Opens or closes the header navigation.
   * @param {object} props
   *   Navigation props.
   * @param {boolean} state
   *   State which to transition the header navigation menu into.
   */
  function toggleNav(props, state) {
    const value = !!state;
    props.navButton.setAttribute('aria-expanded', value);

    if (value) {
      props.body.classList.add('js-overlay-active');
      props.body.classList.add('js-fixed');
      props.navWrapper.classList.add('is-active');
    }
    else {
      props.body.classList.remove('js-overlay-active');
      props.body.classList.remove('js-fixed');
      props.navWrapper.classList.remove('is-active');
      resetSubNavState();
    }
  }

  /**
   * Init function for header navigation.
   * @param {object} props
   *   Navigation props.
   */
  function init(props) {
    props.navButton.setAttribute('aria-controls', props.navWrapperId);
    props.navButton.setAttribute('aria-expanded', 'false');

    props.navButton.addEventListener('click', function () {
      toggleNav(props, !isNavOpen(props.navWrapper));
    });
    // Closes any open sub navigation first, then close header navigation.
    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape') {
        if (props.olivero && props.olivero.areAnySubNavsOpen()) {
          props.olivero.closeAllSubNav();
        }
        else {
          toggleNav(props, false);
        }
      }
    });

    // Focus trap.
    props.navWrapper.addEventListener('keydown', function (e) {
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === props.firstFocusableEl && !props.olivero.isDesktopNav()) {
            props.navButton.focus();
            e.preventDefault();
          }
        }
        else if (document.activeElement === props.lastFocusableEl && !props.olivero.isDesktopNav()) {
          props.navButton.focus();
          e.preventDefault();
        }
      }
    });
    window.addEventListener('resize', function () {
      if (isDesktopNav()) {
        toggleNav(props, false);
        props.body.classList.remove('js-overlay-active', 'js-fixed');
      }
    });
  }

  /**
   * Initialize the navigation JS.
   * This was modified by Palantir to include a functionalble calling for
   * triggering the menu.
   */
  function initializeMenu() {
    const mainNav = document.querySelector('[data-menu-name="main"]');
    if (mainNav.dataset?.navL1Init === 'true') {
      return;
    }
    mainNav.dataset.navL1Init = 'true';

    const navWrapperId = 'header-nav';
    const navWrapper = document.querySelector("#".concat(navWrapperId, ":not(.").concat(navWrapperId, "-processed)"));

    if (navWrapper) {
      navWrapper.classList.add("".concat(navWrapperId, "-processed"));
      const navButton = document.querySelector('.mobile-nav-button');
      const body = document.querySelector('body');
      const focusableNavElements = navWrapper.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      const firstFocusableEl = focusableNavElements[0];
      const lastFocusableEl = focusableNavElements[focusableNavElements.length - 1];

      init({
        navWrapperId: navWrapperId,
        navWrapper: navWrapper,
        navButton: navButton,
        body: body,
        firstFocusableEl: firstFocusableEl,
        lastFocusableEl: lastFocusableEl
      });
    }
  }

  // Trigger this JS after HTML.
  if (typeof window.jQuery === 'function') {
    jQuery(document).one('tabAjaxMenu:ready', initializeMenu);
  } else {
    document.addEventListener('tabAjaxMenu:ready', initializeMenu);
  }
})();

/**
* DO NOT EDIT THIS FILE.
* See the following change record for more information,
* https://www.drupal.org/node/2815083
* @preserve
**/


if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;

    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

(function () {

  /**
   * Wait for it.
   */
  const debounce = (fn, time) => {
    let timeout;

    return function() {
      const functionCall = () => fn.apply(this, arguments);

      clearTimeout(timeout);
      timeout = setTimeout(functionCall, time);
    }
  }

  /**
   * Checks for mobile buttons.
   * This originally came from Drupal.olivero so we needed to improvise for the
   * current installation.
   */
  function isDesktopNav() {
    let navButtons = document.querySelector('.mobile-buttons');
    return getComputedStyle(navButtons).getPropertyValue('display') === 'none';
  }

  /**
   * Get siblings of element.
   *
   * @param {element} The element.
   */
  function getSiblings(elem) {
    // Setup siblings array and get the first sibling
    let siblings = [];
    let sibling = elem.parentNode.firstChild;

    // Loop through each sibling and push to the array
    while (sibling) {
      if (sibling.nodeType === 1 && sibling !== elem) {
        siblings.push(sibling);
      }
      sibling = sibling.nextSibling
    }
    return siblings;
  }

  /**
   * Shows and hides the specified menu item's second level submenu.
   *
   * @param {element} topLevelMenuITem - the <li> element that is the container for the menu and submenus.
   * @param {boolean} [toState] - Optional state where we want the submenu to end up.
   */
  function toggleSubNav(topLevelMenuITem, toState) {
    const button = topLevelMenuITem.querySelector('.primary-nav__button-toggle, .primary-nav__menu-link--button');
    const state = toState !== undefined ? toState : button.getAttribute('aria-expanded') !== 'true';
    const siblings = getSiblings(topLevelMenuITem);

    if (state) {
      button.setAttribute('aria-expanded', 'true');
      topLevelMenuITem.querySelector('.primary-nav__menu').classList.add('is-active');

      siblings.forEach(function (el) {
        if (el.classList.contains('primary-nav__menu-item--has-children')) {
          let siblingsChildren = el.querySelectorAll('.primary-nav__menu');
          siblingsChildren.forEach((uls) => {
            uls.classList.remove('is-active')
          });

          siblingsChildren = el.querySelectorAll('.primary-nav__button-toggle');
          siblingsChildren.forEach((button) => {
            button.setAttribute('aria-expanded', 'false')
          });

        }
      });

    } else {
      button.setAttribute('aria-expanded', 'false');
      topLevelMenuITem.querySelector('.primary-nav__menu').classList.remove('is-active');

      // Reset any nested submenu state when parent submenu closes.
      topLevelMenuITem.querySelectorAll('.primary-nav__button-toggle')
        .forEach((nestedButton) => {
          nestedButton.setAttribute('aria-expanded', 'false');
        });
      topLevelMenuITem.querySelectorAll('.primary-nav__menu')
        .forEach((nestedMenu) => {
          nestedMenu.classList.remove('is-active');
        });
    }
  }

  /**
   * Initialize the navigation JS.
   * This was modified by Palantir to include a functionalble calling for
   * triggering the menu.
   */
  function initializeMenu2() {
    const mainNav = document.querySelector('[data-menu-name="main"]');
    if (mainNav.dataset?.navL2Init === 'true') {
      return;
    }
    mainNav.dataset.navL2Init = 'true';

    const secondLevelNavMenus = document.querySelectorAll('.primary-nav__menu-item--has-children');

    secondLevelNavMenus.forEach(function (el) {
      const button = el.querySelector('.primary-nav__button-toggle, .primary-nav__menu-link--button, .primary-nav__menu-link--nolink');

      if (button) {
        button.removeAttribute('aria-hidden');
        button.removeAttribute('tabindex');
        button.addEventListener('click', function (e) {
          const topLevelMenuITem = e.currentTarget.parentNode;
          toggleSubNav(topLevelMenuITem);
        });
      }

      el.addEventListener('mouseenter', function (e) {
        if (isDesktopNav()) {
          debounce(toggleSubNav(e.currentTarget, true), 1000);
        }
      });
      el.addEventListener('mouseleave', function (e) {
        if (isDesktopNav()) {
          debounce(toggleSubNav(e.currentTarget, false), 1000);
        }
      });
    });

    let secondaryLinksWithChildren = document.querySelectorAll('.primary-nav__menu-item--level-2.primary-nav__menu-item--has-children');
    secondaryLinksWithChildren.forEach(function (el) {
      el.addEventListener('mouseenter', function (e) {
        el.querySelector('.primary-nav__menu--level-3').style.left = el.parentNode.offsetWidth + 'px';
      });
    });

    // On hitting escape key, close all the subnavs.
    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape' && isDesktopNav()) {
        closeAllSubNav();
      }
    });
  }

  /**
   * Close all second level sub navigation menus.
   */
  function closeAllSubNav() {
    const secondLevelNavMenus = document.querySelectorAll('.primary-nav__menu-item--has-children');
    secondLevelNavMenus.forEach(function (el) {
      toggleSubNav(el, false);
    });
  }

  /**
   * Checks if any sub navigation items are currently active.
   * @return {boolean} If sub nav is currently open.
   */
  function areAnySubNavsOpen() {
    const secondLevelNavMenus = document.querySelectorAll('.primary-nav__menu-item--has-children');
    let subNavsAreOpen = false;
    secondLevelNavMenus.forEach(function (el) {
      const button = el.querySelector('.primary-nav__button-toggle');
      const state = button.getAttribute('aria-expanded') === 'true';

      if (state) {
        subNavsAreOpen = true;
      }
    });
    return subNavsAreOpen;
  }

  // Trigger this JS after HTML.
  if (typeof window.jQuery === 'function') {
    jQuery(document).one('tabAjaxMenu:ready', initializeMenu2);
  } else {
    document.addEventListener('tabAjaxMenu:ready', initializeMenu2);
  }
})();

/**
 * Global Footer Language Switcher component interaction
 *
 * Provides accessible language switching functionality for the global footer.
 * Implements WCAG 2.1/2.2 Level A compliance:
 * - SC 3.2.1 On Focus (Level A) - Focus doesn't automatically open dropdown.
 * - SC 2.4.3 Focus Order (Level A) - Natural tab order through links.
 * - SC 2.1.1 Keyboard (Level A) - Click to open/close, ESC to close.
 *
 * Uses aria-haspopup="true" and aria-expanded="true/false" pattern.
 *
 * Interactions:
 * - Click button with Enter or Space: Opens/closes dropdown.
 * - Mouse hover:  Opens/closes dropdown. (handled in CSS)
 * - ESC key: Closes dropdown.
 * - Tab: Natural focus through dropdown links.
 * - Click outside: Closes dropdown.
 */

(function () {
  const languageContainer = document.querySelector('.global-footer__language');
  const toggle = languageContainer?.querySelector('.global-footer__language__toggle');
  const options = languageContainer?.querySelector('.global-footer__language__options');

  // Exit if language switcher doesn't exist.
  if (!languageContainer || !toggle || !options) {
    return;
  }

  // Remove class and update aria attributes.
  function closeDropdown() {
    languageContainer.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    options.setAttribute('aria-hidden', 'true');
    options.setAttribute('inert', '');
  }

  // Add class and update aria attributes.
  function openDropdown() {
    languageContainer.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    options.setAttribute('aria-hidden', 'false');
    options.removeAttribute('inert');
  }

  // Handle keyboard events on the toggle button.
  toggle.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      languageContainer.classList.contains('is-open')
        ? closeDropdown()
        : openDropdown();
    }
  });

  // Close dropdown when clicking outside.
  document.addEventListener('click', function (e) {
    if (!languageContainer.contains(e.target) && languageContainer.classList.contains('is-open')) {
      closeDropdown();
    }
  });

  // Close dropdown on ESC key.
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && languageContainer.classList.contains('is-open')) {
      closeDropdown();
      toggle.focus();
    }
  });

  // Ensure the inert attribute is being removed and added during hover, otherwise if inert
  // is left on the element, the dropdown does not work with hover.
  languageContainer.addEventListener('mouseenter', function () {
    openDropdown();
  });
  languageContainer.addEventListener('mouseleave', function () {
    closeDropdown();
  });
})();
